import { render, staticRenderFns } from "./MarketDynamics.vue?vue&type=template&id=7e9ecea2&scoped=true"
import script from "./MarketDynamics.vue?vue&type=script&lang=js"
export * from "./MarketDynamics.vue?vue&type=script&lang=js"
import style0 from "./MarketDynamics.vue?vue&type=style&index=0&id=7e9ecea2&prod&scoped=true&lang=css"
import style1 from "./MarketDynamics.vue?vue&type=style&index=1&id=7e9ecea2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e9ecea2",
  null
  
)

export default component.exports